import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "card-content",
  templateUrl: "./card-content.component.html",
  styleUrl: "./card-content.component.scss",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardContentComponent {}
